import { gql } from "@apollo/client";

export const CREATE_GROUP = gql`
  mutation CreateGroup($input:CreateGroupInput) {
    createGroup(input:$input) {
      data {
        group {
          icon
          eligibility
          id
          group_order
          folder_id
          image
          updated_at
          button_name
          description
          created_at
          name
        }
      }
      error {
        code
        field
        message
      }
    }
  }
`;

export const UPDATE_GROUP = gql`
  mutation UpdateGroup($input:CreateGroupInput, $group_id: UUID!, $folder_id: String!) {
    updateGroup(input: $input, group_id: $group_id, folder_id: $folder_id) {
      data {
        group {
              icon
                eligibility
                id
                group_order
                folder_id
                image
                updated_at
                button_name
                description
                created_at
                name
        }
      }
      error {
        code
        field
        message
      }
    }
  }
`;

export const DELETE_GROUP = gql`
  mutation DeleteGroup($folder_id: String!, $group_id: UUID!) {
    deleteGroup(folder_id: $folder_id, group_id: $group_id) {
      data {
        message
      }
      error {
        message
      }
    }
  }
`;
